import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, ChevronDown } from 'lucide-react';

const Header = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          {/* Logo */}
          {/* Logo */}
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/images/logo2.jpg"
              alt="Tarr Logo"
              className="h-14 w-auto"
            />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm tracking-wide transition-colors ${isActive('/') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
                }`}
            >
              {t.nav.home}
            </Link>
            <Link
              to="/about"
              className={`text-sm tracking-wide transition-colors ${isActive('/about') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
                }`}
            >
              {t.nav.about}
            </Link>
            <Link
              to="/contact"
              className={`text-sm tracking-wide transition-colors ${isActive('/contact') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
                }`}
            >
              {t.nav.contact}
            </Link>
          </nav>

          {/* Language Switcher & Mobile Menu */}
          <div className="flex items-center space-x-4">
            {/* Language Switcher */}
            <div className="relative group">
              <button className="flex items-center space-x-1 text-sm text-gray-600 hover:text-gray-900 transition-colors">
                <span className="uppercase">{language}</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute right-0 mt-2 w-24 bg-white border border-gray-200 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <button
                  onClick={() => changeLanguage('en')}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                >
                  English
                </button>
                <button
                  onClick={() => changeLanguage('tr')}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                >
                  Türkçe
                </button>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-600 hover:text-gray-900"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-wide ${isActive('/') ? 'text-gray-900 font-medium' : 'text-gray-600'
                  }`}
              >
                {t.nav.home}
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-wide ${isActive('/about') ? 'text-gray-900 font-medium' : 'text-gray-600'
                  }`}
              >
                {t.nav.about}
              </Link>
              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-wide ${isActive('/contact') ? 'text-gray-900 font-medium' : 'text-gray-600'
                  }`}
              >
                {t.nav.contact}
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;